import Confirmed from './Confirmed';

export default Confirmed;
